/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import moment from "moment";
import { Calendar } from "lucide-react";
declare const $: any;

interface DatePickerProps {
  onDateChange: (dateRange: string) => void;
  initialDateRange?: string;
  placeholder?: string;
}

const DatePicker = ({
  onDateChange,
  initialDateRange,
  placeholder = "Select Date",
}: DatePickerProps) => {
  const [dateRange, setDateRange] = useState("");

  useEffect(() => {
    const input = $(".date-ranger");

    // 📅 Default = This Month
    const defaultStart = moment().startOf("month");
    const defaultEnd = moment().endOf("month");
    const defaultFormatted = `${defaultStart.format(
      "MMM DD, YYYY"
    )} - ${defaultEnd.format("MMM DD, YYYY")}`;

    if (input.length > 0 && typeof input.daterangepicker === "function") {
      input.daterangepicker(
        {
          startDate: defaultStart,
          endDate: defaultEnd,
          locale: { format: "MMM DD, YYYY" },
          ranges: {
            Today: [moment(), moment()],
            "Last 7 Days": [moment().subtract(6, "days"), moment()],
            "This Month": [moment().startOf("month"), moment().endOf("month")],
            "Last Month": [
              moment().subtract(1, "month").startOf("month"),
              moment().subtract(1, "month").endOf("month"),
            ],
          },
          autoApply: true,
        },
        function (start: any, end: any) {
          const newValue = `${start.format("MMM DD, YYYY")} - ${end.format(
            "MMM DD, YYYY"
          )}`;
          setDateRange(newValue);
          onDateChange(newValue);
        }
      );

      // ⬅️ Set default "This Month"
      input.val(defaultFormatted);
      setDateRange(defaultFormatted);
      onDateChange(defaultFormatted);

      // ⬅️ Override with initialDateRange if provided
      if (initialDateRange) {
        const parts = initialDateRange.split(" - ");
        if (parts.length === 2) {
          const start = moment(parts[0], "MMM DD, YYYY");
          const end = moment(parts[1], "MMM DD, YYYY");
          input.data("daterangepicker").setStartDate(start);
          input.data("daterangepicker").setEndDate(end);
          input.val(initialDateRange);
          setDateRange(initialDateRange);
          onDateChange(initialDateRange);
        }
      }
    }

    // 🧹 Cleanup
    return () => {
      const picker = input.data("daterangepicker");
      if (picker) picker.remove();
    };
  }, []);

  return (
    <>
      <span className="input-icon icon-left">
        <span>
          <Calendar size={16} />
        </span>
      </span>

      <input
        type="text"
        className="form-control form-control-default date-ranger"
        name="date-ranger"
        placeholder={placeholder}
        value={dateRange}
        onChange={(e) => setDateRange(e.target.value)}
        style={{ backgroundColor: "#ffff" }}
      />

      <span className="input-icon icon-right">
        <span data-feather="chevron-down"></span>
      </span>
    </>
  );
};

export default DatePicker;
